<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-left">
        <img src="@/assets/login/ddtd.png" alt="Illustration" class="login-illustration">
      </div>
      <div class="login-right">
        <div class="login-header">
          <div class="title-wrapper">
            <span>欢迎</span>
            <span class="highlight-underline">登录</span>
            <span>垃圾分类管理系统</span>
          </div>
        </div>
        <el-form ref="loginForm" :model="loginForm" :rules="rules" class="login-form">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入用户名">
              <template slot="prefix">
                <div class="input-icon-wrapper">
                  <img src="@/assets/login/username.png" class="input-icon" alt="user">
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" show-password>
              <template slot="prefix">
                <div class="input-icon-wrapper">
                  <img src="@/assets/login/password.png" class="input-icon" alt="password">
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleLogin" :loading="loading" class="login-button">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const response = await this.$store.dispatch('auth/login', this.loginForm)
            let isSuccess = false
            if (response) {
              isSuccess = response.code === 0 ||
                          response.code === 200 || 
                          response.code === "SUCCESS" || 
                          response.success === true ||
                          (response.data && 
                           (response.data.code === 0 ||
                            response.data.code === 200 || 
                            response.data.code === "SUCCESS" || 
                            response.data.success === true))
            }
            
            if (isSuccess) {
              this.$message.success('登录成功')
              this.$router.push('/home')
            } else {
              const errorMessage = response.message || 
                                  (response.data && response.data.message) || 
                                  '登录失败'
              this.$message.error(errorMessage)
            }
          } catch (error) {
            let errorMessage = '登录失败，请检查网络连接或稍后重试'
            if (error && typeof error === 'object') {
              if (error.message) {
                errorMessage = error.message
              } else if (error.response && error.response.data) {
                errorMessage = error.response.data.message || JSON.stringify(error.response.data)
              } else if (error.code) {
                errorMessage = `登录错误 (${error.code})`
              }
            }
            this.$message.error(errorMessage)
          } finally {
            this.loading = false
          }
        }
      })
    }
  },
  mounted() {
    const savedUsername = localStorage.getItem('username')
    if (savedUsername) {
      this.loginForm.username = savedUsername
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: url('~@/assets/login/back.png') center/cover no-repeat;
  position: relative;
  overflow: hidden;
}

.login-card {
  display: flex;
  width: 900px;
  height: 500px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 1;
}

.login-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f9eb; /* Light green tint to match the trash bin theme */
  position: relative;
}

/* Optional: Dashed border effect as seen in some designs, but maybe not needed if image has it. 
   Assuming the image ddtd.png contains the main illustration. */
.login-illustration {
  max-width: 80%;
  height: auto;
  object-fit: contain;
}

.login-right {
  flex: 1;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.title-wrapper {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  letter-spacing: 1px;
}

.highlight-underline {
  position: relative;
  display: inline-block;
}

.highlight-underline::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #42b983; /* Green underline */
  border-radius: 2px;
  z-index: -1;
}

.login-form {
  width: 100%;
  padding: 0 20px;
}

.el-form-item {
  margin-bottom: 25px;
}

/* Customizing Input */
::v-deep .el-input__inner {
  border-radius: 4px;
  height: 45px;
  line-height: 45px;
  border: 1px solid #dcdfe6;
  padding-left: 45px; /* Make space for icon */
}

::v-deep .el-input__inner:focus {
  border-color: #42b983;
}

.input-icon-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
}

.input-icon {
  width: 20px;
  height: 20px;
}

.login-button {
  width: 100%;
  height: 45px;
  border-radius: 4px;
  font-size: 16px;
  background-color: #38b63c; /* Green button */
  border-color: #38b63c;
  letter-spacing: 4px;
}

.login-button:hover, .login-button:focus {
  background-color: #2ea132;
  border-color: #2ea132;
}
</style>
